// extracted by mini-css-extract-plugin
module.exports = {"steps":"_9sffrX","step":"_2nAhBu","inactiveFlag":"EebbAc","activeFlag":"_1mcRce","bird":"_2W0MK9","inactiveBag":"_2CAtjs","activeBag":"_3CpN3n","arrow":"JZNujK","active":"_2Ssb2G"};